module.exports = __webpack_public_path__ + "static/media/prizes.d02fa6fa.png";